import { lazy } from "react"
import type { RouteObject } from "react-router-dom"
import Root from "./layout/Root"
import Home from "./pages/Home"
import About from "./pages/About"
import Work from "./pages/Work"
import WorkDetail from "./pages/WorkDetail"
import Process from "./pages/Process"
import Insights from "./pages/Insights"
import InsightDetail from "./pages/InsightDetail"
import Contact from "./pages/Contact"
import Questionnaire from "./pages/Questionnaire"
import Privacy from "./pages/Privacy"
import Terms from "./pages/Terms"
import NotFound from "./pages/NotFound"

/* The studio dashboard is never used by a public visitor, so it is split out of
   the main bundle. Only /admin/* pays for it. */
const AdminLayout = lazy(() => import("./admin/AdminLayout"))
const Overview = lazy(() => import("./admin/pages/Overview"))
const AdminProjects = lazy(() => import("./admin/pages/Projects"))
const CaseStudies = lazy(() => import("./admin/pages/CaseStudies"))
const Blog = lazy(() => import("./admin/pages/Blog"))
const Financials = lazy(() => import("./admin/pages/Financials"))
const Leads = lazy(() => import("./admin/pages/Leads"))
const Contacts = lazy(() => import("./admin/pages/Contacts"))
const Submissions = lazy(() => import("./admin/pages/Submissions"))
const Settings = lazy(() => import("./admin/pages/Settings"))

export const routes: RouteObject[] = [
  {
    path: "/",
    Component: Root,
    children: [
      { index: true, Component: Home },
      { path: "about", Component: About },
      { path: "work", Component: Work },
      { path: "work/:slug", Component: WorkDetail },
      { path: "process", Component: Process },
      { path: "insights", Component: Insights },
      { path: "insights/:slug", Component: InsightDetail },
      { path: "contact", Component: Contact },
      { path: "questionnaire", Component: Questionnaire },
      { path: "privacy", Component: Privacy },
      { path: "terms", Component: Terms },
      { path: "*", Component: NotFound },
    ],
  },
  {
    path: "/admin",
    Component: AdminLayout,
    children: [
      { index: true, Component: Overview },
      { path: "projects", Component: AdminProjects },
      { path: "case-studies", Component: CaseStudies },
      { path: "blog", Component: Blog },
      { path: "financials", Component: Financials },
      { path: "leads", Component: Leads },
      { path: "contacts", Component: Contacts },
      { path: "submissions", Component: Submissions },
      { path: "settings", Component: Settings },
    ],
  },
]
